<div class="check" [class.small-switch]="isSmallSwitchButton">
  <div [class.disabled-wrapper]="isDisabled">
    <label class="switch" [class.disabled]="isDisabled">
      <input
        type="checkbox"
        [ngModel]="checkedValue"
        (change)="handleClick($event)"
        [formControl]="switchControl"
      />
      <span class="slider round"></span>
    </label>
  </div>
</div>
